/* Voice & live (VOICE-01..06). Shared: `DictationButton` and `applyDictation` from
   './DictationButton' for any text field (requested for the Composer in docs/core-requests.md). */
import { lazy } from 'react';
import { AudioLines } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'voice',
  title: 'Voice & live',
  short: 'Voice',
  icon: AudioLines,
  group: 'Work',
  route: '/voice',
  order: 70,
  rail: true,
  screen: lazy(() => import('./Screen.tsx')),
  capabilities: ['VOICE-01', 'VOICE-02', 'VOICE-03', 'VOICE-04', 'VOICE-05', 'VOICE-06'],
  commands: [
    { id: 'voice-start', title: 'Start voice mode', to: '/voice', keywords: ['talk', 'speak', 'live', 'mic'] },
    { id: 'voice-screen', title: 'Share my screen with the assistant', to: '/voice/screen', keywords: ['screen share', 'walk me through'] },
    { id: 'voice-dictate', title: 'Dictate text', to: '/voice/dictate', keywords: ['dictation', 'speech to text'] },
    { id: 'voice-read', title: 'Read aloud', to: '/voice/readaloud', keywords: ['listen', 'tts', 'narrate'] },
    { id: 'voice-translate', title: 'Live translation', to: '/voice/translate', keywords: ['interpreter', 'subtitles', 'language'] },
  ],
});
